module.exports = __webpack_public_path__ + "static/media/reinvite.e8b3e293.svg";